import { api } from "@/api";
import { Form, Input } from "antd";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Swal from "sweetalert2";

const onFinishFailed = (errorInfo) => {
  // eslint-disable-next-line no-console
  console.log("Failed:", errorInfo);
};

const EditDTModel = (props) => {
  const { deviceTypeDataToEdit, getDeviceTypes, setModalShow } = props;
  const [form] = Form.useForm();

  const [isLoading, setIsLoading] = useState(false);

  const onFinish = async (values) => {
    setIsLoading(true);
    try {
      const response = await api.put(`/device-type/${deviceTypeDataToEdit._id}`, values);
      if (response) {
        await Swal.fire({
          title: "Done!",
          text: "Device Type Edited Successfully",
          icon: "success",
          timer: 2000,
          confirmButtonText: "OK",
        });
        getDeviceTypes();
        setModalShow(false);
      }
    } catch {
      Swal.fire({
        title: "",
        text: "Something went wrong",
        icon: "error",
        timer: 2000,
        confirmButtonText: "OK",
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    form.setFieldsValue({ name: deviceTypeDataToEdit.name, description: deviceTypeDataToEdit.description });
  }, [deviceTypeDataToEdit]);

  return (
    <Modal {...props} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Body>
        <h4 className="text-center">Edit Building Type</h4>
        <div className="d-flex justify-content-center">
          {isLoading && <Spinner animation="border" variant="dark" />}
        </div>
        <Form
          layout="vertical"
          name="deviceType"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          form={form}
          size="large"
          initialValues={{ ...deviceTypeDataToEdit }}
        >
          <Form.Item
            label="Device Type Name"
            name="name"
            rules={[{ required: true, message: "Device Type Name is required" }]}
          >
            <Input placeholder="Enter Device Type Name" />
          </Form.Item>

          <Form.Item label="Device Type Description" name="description">
            <Input placeholder="Enter Device Type Description" />
          </Form.Item>

          <div className="float-end">
            <button type="submit" className="btn btn-success me-2">
              Save
            </button>
            <button type="button" className="btn btn-secondary" onClick={() => setModalShow(false)}>
              Cancel
            </button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default EditDTModel;

EditDTModel.propTypes = {
  deviceTypeDataToEdit: PropTypes.object,
  getDeviceTypes: PropTypes.func,
  setModalShow: PropTypes.func,
};
